export class callsTodayHistory {
    constructor(callsTodayObj) {
        this.callID                 = callsTodayObj.CallId;        	
        this.callKey		        = callsTodayObj.CallKey;        	
        this.callType	            = callsTodayObj.CallType;        	
        this.camManualMode          = callsTodayObj.CamManualMode;        	
        this.campName	            = callsTodayObj.Description;        	
        this.dispositionName	    = callsTodayObj.Disposition;        	
        this.callDuration		    = callsTodayObj.Duration;        	
        this.graphicID  		    = callsTodayObj.GraphicID;        	
        this.hidePhone  		    = callsTodayObj.HidePhone;        	
        this.date		            = callsTodayObj.Hour;        	
        this.campID     		    = callsTodayObj.IDCampEsp;        	
        this.rotativeAniManualCall	= callsTodayObj.SelectRotativeAniManualCall;        	
        this.phone	        	    = callsTodayObj.Telephone;
    }
}